/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Relation type
 */
export type DeviceRelationType = (typeof DeviceRelationType)[keyof typeof DeviceRelationType];

export const DeviceRelationType = {
  PARENT_CHILD: 'parent_child',
  DC_DM: 'dc_dm',
} as const;
